import React, {useState} from "react"
import Grid from "@mui/material/Grid2";
import {Typography} from "@mui/material";
import PrintReceipt from "../Common/PrintReceipt";
import DoYouWantInspectionReminder from "../InspectionReminder/DoYouWantInspectionReminder";
import {useSelector} from "react-redux";
import {RootState} from "../../../Redux";
import {useTranslation} from "react-i18next";
import {getLocale, getTranslatatedPropertyValue} from "../../../Utils/helpers";
import {ServiceCardType} from "../Types";
import InspectionReminder from "../InspectionReminder/InspectionReminder";
import {SelfServiceSettingsType} from '../../../interfaces'
import ReturnToStartScreenTimer from "../Common/ReturnToStartScreenTimer";

interface MoveSuccessProps {
    serviceCard: ServiceCardType
    paymentDone: boolean
}

const MoveSuccess = ({ serviceCard, paymentDone = false }: MoveSuccessProps) => {
    const { t } = useTranslation()
    const language = getLocale()

    const [inspectionReminder, setInspectionReminder] = useState<boolean>()
    const [time, setTime] = useState<number|null>(null)

    const settings: SelfServiceSettingsType = useSelector((state: RootState) => state.ui.settings?.selfService ?? {});

    const completedInfo = useSelector((state: RootState) => getTranslatatedPropertyValue(state.ui.settings.selfService, 'completedInfo', language))

    const text = paymentDone ? t('selfService.paymentSucceeded') : t('selfService.registrationSuccessMessage')

    const onPrintDone = () => {
        setTime(10)
    }

    const onReminderBack = () => {
        setInspectionReminder(undefined)
    }

    if (inspectionReminder !== undefined) {
        return (
            <InspectionReminder
                orderReminder={inspectionReminder}
                serviceCard={serviceCard}
                onBack={onReminderBack}
                thankYouMessage={t('selfService.waitForService')}
            />
        )
    }

    return (
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className={'pageMainContainer'}>
            <Grid />
            <Grid>
                <Typography variant="h4">{text}</Typography>
            </Grid>
            <Grid justifyItems="center" className="contentWithMargin">
                <Typography variant="subtitle1" gutterBottom>
                    {`${t('common.vehicle')} ${t('selfService.inWorkQueue')}`}
                </Typography>
                <Typography variant="subtitle1" color="error" gutterBottom>{completedInfo}</Typography>
            </Grid>
            <Grid>
                <PrintReceipt serviceCard={serviceCard} type={"registrationNumber"} onPrintDone={onPrintDone}/>
            </Grid>
            <ReturnToStartScreenTimer time={60} showCloseButton={false}/>
            {time !== null && settings.inspectionReminderAvailable &&
                <Grid>
                    <DoYouWantInspectionReminder onSelect={setInspectionReminder}/>
                </Grid>
            }
            <Grid />
        </Grid>
    )
}

export default MoveSuccess
